import React from 'react';
import './homepage.css';

function InfoCards() {
  return (
    <section className="hp-info-cards" aria-label="Contact information">
      <div className="hp-info-cards__grid">
        <div className="hp-info-cards__card">
          <div className="hp-info-cards__icon"><img src="/assets/icons/map-icon.png" alt="" /></div>
          <div className="hp-info-cards__body">
            <span>Longcroft House,</span>
            <span>2-8 Victoria Avenue,</span>
            <span>London,</span>
            <span>EC2M 4NS</span>
          </div>
        </div>
        <div className="hp-info-cards__card">
          <div className="hp-info-cards__icon"><img src="/assets/icons/time-icon.png" alt="" /></div>
          <div className="hp-info-cards__body">
            <span className="hp-info-cards__label">Monday-Thursday</span>
            <span>09:00 – 17:00</span>
          </div>
        </div>
        <div className="hp-info-cards__card">
          <div className="hp-info-cards__icon"><img src="/assets/icons/contact-icon.png" alt="" /></div>
          <div className="hp-info-cards__body">
            <span className="hp-info-cards__label">Mail Us</span>
            <a href="mailto:info@myprivatechemist.com" className="hp-info-cards__link">info@myprivatechemist.com</a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default InfoCards;
